import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';
import LoadingSpinner from '../../../components/LoadinSpinner';
import TitlePage from '../../../components/TitlePage';
import SubmitForm from '../../../components/SubmitForm';
import InputGeral from '../../../components/InputGeral/Index';
import SelectFixo from '../../../components/SelectFixo';
import { SucessoMsg, formatarData, formatDateComponent } from '../../../contents/VariaveisGlobais'
import { ConsumoAPI_POST, ConsumoAPI_PUT } from '../../../../backend/ConsumoAPI';
import { format } from 'date-fns';
import ConsultaTarefasAgendadas from '../../../../lib/json/consultas/TarefasAgendadas.json'
import { ConsultaAPI } from '../../../../backend/ConsultaAPI';

function FichaTarefasAgendadas(){
	const [campoDescricao, setCampoDescricao] = useState('');
	const [campoDiadoMes, setCampoDiadoMes] = useState({value: '*', text: 'Todos'});
	const [campoMes, setCampoMes] = useState({value: '*', text: 'Todos'});
	const [campoDiadaSemana, setCampoDiadaSemana] = useState({value: '*', text: 'Todos'});
	const [campoHorario, setCampoHorario] = useState('');
	const [campoTarefa, setCampoTarefa] = useState('');
	const [campoRecorente, setCampoRecorente] = useState({value: 'S', text: 'Sim'});
	const [campoHabilitado, setCampoHabilitado] = useState({value: 'S', text: 'Sim'});
	const [campoDataEvento, setCampoDataEvento] = useState();
	const [carregar, setCarregar] = useState(false);
	
	const monthNames = [
		"Janeiro", "Fevereiro", "Março",
		"Abril", "Maio", "Junho", "Julho",
		"Agosto", "Setembro", "Outubro",
		"Novembro", "Dezembro"
	];

	const dayOfWeekNames = [
		"Domingo", "Segunda-feira", "Terça-feira",
		"Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"
	];

	const [inclusao, setInclusao] = useState(true);
	const { idAgendamentoTarefasAgendadas } = useParams();
	const isFormVisual = window.location.href.includes('Visualizar');
    
    const [disabledForm, setDisabledForm] = useState(isFormVisual);

	const handleSalvar = async() => {
		const jsonSalvar = {
			descricao: campoDescricao, 
			habilitado: campoHabilitado.value, 
			recorrente: campoRecorente.value, 
			data: ( campoDataEvento ? format(campoDataEvento, "yyyy-MM-dd HH:mm:ss") : null ), 
			dia: campoDiadoMes.value, 
			mes: campoMes.value, 
			diaSemana: campoDiadaSemana.value, 
			horario: campoHorario, 
			tarefa: campoTarefa
		}

		const rota = 'tarefasAgendadas' + (inclusao ? '' : '/' + idAgendamentoTarefasAgendadas);
		let retConsumo = await (inclusao
			? ConsumoAPI_POST(rota, jsonSalvar)
			: ConsumoAPI_PUT(rota, jsonSalvar));

		SucessoMsg(retConsumo.description);
	};

	const generateOptions = (start, end, mes = false, diaSemana = false, diasMes = false) => {
		let options = [{ value: "*", text: "Todos"}];

		if (diasMes){
			options.push({ value: "U", text: "Executar no Ultima dia do Mês"});
		}

		for (let i = start; i <= end; i++) {
			if (mes) {
				options.push({ value: i, text: monthNames[i - 1] });
			} else if (diaSemana) {
				options.push({ value: i, text: dayOfWeekNames[i] });
			} else {
				options.push({ value: i, text: i });
			}
		}

		return options;
	};

	const optionsCampoDiadoMes = generateOptions(1, 31, false, false, true);
	const optionsCampoMes = generateOptions(1, 12, true);
	const optionsCampoDiadaSemana = generateOptions(0, 6, false, true);

	const loadFichaTarefasAgendadas = async() => {
        setCarregar(true);
		
		let consultaDefault = ConsultaTarefasAgendadas.consulta
		consultaDefault += " WHERE Id = '" + idAgendamentoTarefasAgendadas + "'"

		var retConsulta = await ConsultaAPI( consultaDefault );

		if (retConsulta.data){
			const Agendamento = retConsulta.data[0]
			const diaMes = Agendamento.Dia == '*' ? 'Todos' : Agendamento.Dia == 'U' ? 'Executar no Ultima dia do Mês' : Agendamento.Dia
			const mes = Agendamento.Mes == '*' ? 'Todos' :  monthNames[Agendamento.Mes - 1]
			const diaSemana = Agendamento.DiaSemana  == '*' ? 'Todos' : dayOfWeekNames[Agendamento.DiaSemana] 
			const recorrente = Agendamento.Recorrente  == 'S' ? 'Sim' : 'Não'
			const habilitado = Agendamento.Habilitado  == 'S' ? 'Sim' : 'Não'

			setCampoDescricao(Agendamento.Descricao)
			setCampoDiadoMes({value: Agendamento.Dia, text: diaMes})
			setCampoMes({value: Agendamento.Mes, text: mes})
			setCampoDiadaSemana({value: Agendamento.DiaSemana, text: diaSemana})
			setCampoHorario(Agendamento.Horario)
			setCampoTarefa(Agendamento.Tarefa)
			setCampoRecorente({value: Agendamento.Recorrente, text: recorrente})
			setCampoHabilitado({value: Agendamento.Habilitado, text: habilitado})
			setCampoDataEvento(formatDateComponent(formatarData(Agendamento.Data)))
		}

        setCarregar(false);
	}
    
	useEffect(() => {
        if (idAgendamentoTarefasAgendadas){
            if (!disabledForm){
                setInclusao(false)
            }

            loadFichaTarefasAgendadas();
        }else{
			let stringTarefa = 'function PROCESSAR(){ ';
			stringTarefa += '\n	return "TEXTO DE RETORNO DE PROCESSAMENTO"; ';
			stringTarefa += '\n}';
			stringTarefa += '\n';
			stringTarefa += '\nPROCESSAR();';

			setCampoTarefa(stringTarefa);
		}
    }, []);

	return ( <>
        <Row>
            <LoadingSpinner isLoading={carregar}/>
            <Col md="12" xs="12">
                <TitlePage text="Agendador de Tarefas"/>
            </Col>
        </Row>
        <Row>
            <Col md="10" xs="12">
                <InputGeral 
                    label="Nome da Tarefa"
                    tipo='text'
                    value={campoDescricao}  // Define o valor do campo com base no estado
                    onChange={(e) => setCampoDescricao(e.target.value)}
					disabled={disabledForm}
				/>
            </Col>
			<Col md="2" xs="12">
                <SelectFixo 
                    options={[{value: 'S', text: 'Sim'}, {value: 'N', text: 'Não'}]} 
                    value={campoHabilitado} 
                    selectedOptionValue={campoHabilitado} 
                    isLabel={true} 
                    label="Habilitado: " 
                    onChange={(e) => setCampoHabilitado(e)}
					disabled={disabledForm}
				/>
            </Col>
			<Col md="2" xs="12">
                <SelectFixo 
                    options={[{value: 'S', text: 'Sim'}, {value: 'N', text: 'Não'}]} 
                    value={campoRecorente} 
                    selectedOptionValue={campoRecorente} 
                    isLabel={true} 
                    label="Recorrente: " 
                    onChange={(e) => setCampoRecorente(e)}
					disabled={disabledForm}
				/>
            </Col>
			{ campoRecorente.value == 'N' && (
				<Col md="3" xs="12">
					<InputGeral
						label="Data"
						tipo='date'
						value={campoDataEvento}  // Use detail.cargo instead of campoEmail
						onChange={(e) => setCampoDataEvento(e.target.value)}
						disabled={disabledForm}
					/>
				</Col>
			)}
			{ campoRecorente.value == 'S' && (
				<>
					<Col md="2" xs="12">
						<SelectFixo 
							options={optionsCampoDiadoMes} 
							value={campoDiadoMes} 
							selectedOptionValue={campoDiadoMes} 
							isLabel={true} 
							label="Dia: " 
							onChange={(e) => setCampoDiadoMes(e)}
							disabled={disabledForm}
						/>
					</Col>
					<Col md="3" xs="12">
						<SelectFixo 
							options={optionsCampoMes} 
							value={campoMes} 
							selectedOptionValue={campoMes} 
							isLabel={true} 
							label="Mês: " 
							onChange={(e) => setCampoMes(e)}
							disabled={disabledForm}
						/>
					</Col>
					<Col md="3" xs="12">
						<SelectFixo 
							options={optionsCampoDiadaSemana} 
							value={campoDiadaSemana} 
							selectedOptionValue={campoDiadaSemana} 
							isLabel={true} 
							label="Dia da Semana: " 
							onChange={(e) => setCampoDiadaSemana(e)}
							disabled={disabledForm}
						/>
					</Col>	
				</>
			)}		
			<Col md="2" xs="12">
				<InputGeral 
					label="Horario: " 
					tipo='hora'
					value={campoHorario}  // Define o valor do campo com base no estado
					onChange={(e) => setCampoHorario(e.target.value)}
					disabled={disabledForm}
				/>
			</Col>	
			<Col md="12" xs="12">
				<InputGeral 
					label="Tarefa"
					tipo='textArea'
					value={campoTarefa}  // Define o valor do campo com base no estado
					onChange={(e) => setCampoTarefa(e.target.value)}
					disabled={disabledForm}
					upperCase={false}
				/>
			</Col>
		</Row>	
		<SubmitForm
			onSave={disabledForm ? null : handleSalvar} 
			onCancel={disabledForm ? null : "handleCancelar"} 
			onVoltar={disabledForm ? "handleCancelar" : null}
		></SubmitForm>
	</>
	);
};

export default FichaTarefasAgendadas;
